export const errorResToMessageArray = res => {
  const messageArray = [];
  try {
    const body = JSON.parse(res.message);
    if (body.errors) {
      for (const errorKey of Object.keys(body.errors)) {
        for (const errorMsg of body.errors[errorKey]) {
          messageArray.push(errorMsg);
        }
      }
    }
  } catch {
    // Intentionally empty — returns empty array below
  }
  return messageArray;
};
